export default "__VITE_ASSET__33c2926c__"